<!-- WIDOK DESKTOP -->
<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row
    class="content"
    routerLink="/app/invitation/edit-invitation/{{ row.id }}"
  >
    <ion-col size="2">
      {{ row.user && row.user.company ? row.user.company.name : "-" }}
    </ion-col>
    <ion-col size="2">
      {{ row.user.firstName }} {{ row.user.lastName }}
    </ion-col>
    <ion-col size="1">
      {{ row.invitationGuests.length + row.invitationEmployees?.length }}
    </ion-col>
    <ion-col size="3">
      {{ row.title }}
    </ion-col>
    <ion-col size="2">
      {{ row.dateStart | dateSti: "onlyDate" }}
    </ion-col>
    <ion-col size="2">
      {{ row.dateStart | dateSti: "onlyHour" }}-{{ row.dateEnd | dateSti: "onlyHour" }}
    </ion-col>
  </ion-row>
</div>
<!-- WIDOK MOBILNY -->

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="/app/invitation/edit-invitation/{{ row.id }}"
>
  <ion-card-header>
    <ion-card-title>{{ row.title }}</ion-card-title>
    <ion-card-subtitle>
      {{
        row.user && row.user.company
          ? row.user.company.name +
            ", " +
            row.user.firstName +
            " " +
            row.user.lastName
          : "-"
      }}
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="no-padding-grid invitation-mobile">
        <div>
          <ion-icon mobile src="assets/icons/clock.svg"></ion-icon>
          <ion-text class="inv-info">
            {{ row.dateStart | dateSti: "onlyHour" }} -
            {{ row.dateEnd | dateSti: "onlyHour" }}
          </ion-text>
        </div>
        <div>
          <ion-icon mobile src="assets/icons/calendar-gray.svg"></ion-icon>
          <ion-text class="inv-info">{{row.dateStart | dateSti:'onlyDate'}}</ion-text>
        </div>
        <div>
          <ion-icon mobile src="assets/icons/people.svg"></ion-icon>
          <ion-text mobile class="inv-info">
            {{ (row.invitationGuests.length + row.invitationEmployees?.length) }}
          </ion-text>
        </div>
    </div>
  </ion-card-content>
</ion-card>
